<template>
  <div class="edit-info-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.edit_info') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.edit_info') }}</div>
    <div class="steps">
      <div class="line-bg show-on-pad"></div>
      <div class="line show-on-pad" :style="{ width: getLineWidth }"></div>
      <div class="step-item" :class="{ active:step>='1' }"><span class="step-title hide-on-pad">STEP1{{ $t('edit_info.step1') }}</span><span class="step-index show-on-pad-flex">1</span></div>
      <div class="step-item" :class="{ active:step>='2' }"><span class="step-title hide-on-pad">STEP2{{ $t('edit_info.step2') }}</span><span class="step-index show-on-pad-flex">2</span></div>
      <div class="step-item" :class="{ active:step>='3' }"><span class="step-title hide-on-pad">STEP3{{ $t('edit_info.step3') }}</span><span class="step-index show-on-pad-flex">3</span></div>
    </div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="editInfo"/>
      </div>
      <div class="page-right step-content">
        <div class="step-content-item" :class="{ active:step=='1' }">
          <div class="form-desc" style="text-align:left;margin-top:0px;">{{ $t('edit_info.required_title') }}</div>
          <div class="form">
            <div class="form-item">
              <!-- 为什幺required分两个写 -->
              <!-- 因为考虑到多国语需要不同文字，以及手机版面和电脑版面不一样，如果写在css里面不知道要怎幺控制 -->
              <div class="form-title required">{{ $t('edit_info.user') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('edit_info.user_placeholder')" v-model="formData.username.value">
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.name') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('edit_info.name')" v-model="formData.name.value">
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.gender') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <div class="label-group">
                    <input type="radio" id="sexM" name="sex" value="1" v-model="formData.sex.value"><label for="sexM">{{ $t('edit_info.male') }}</label>
                  </div>
                  <div class="label-group">
                    <input type="radio" id="sexFM" name="sex" value="2" v-model="formData.sex.value"><label for="sexFM">{{ $t('edit_info.female') }}</label>
                  </div>
                  <div class="label-group">
                    <input type="radio" id="sexO" name="sex" value="3" v-model="formData.sex.value"><label for="sexO">{{ $t('edit_info.no_comment') }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.birthday') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-3">
                  <select name="year" id="" v-model="formData.year.value">
                    <option :value="item" v-for="(item,index) in year" :key="index+'-year'">{{ item }}</option>
                  </select>
                  <select name="mon" id="" v-model="formData.mon.value">
                    <option :value="item" v-for="(item,index) in mon" :key="index+'-mon'">{{ item }}</option>
                  </select>
                  <select name="day" id="" v-model="formData.day.value">
                    <option :value="item" v-for="(item,index) in day" :key="index+'-day'">{{ item }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.addr') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-3">
                  <select v-model="formData.province.value">
                    <option value="">{{ $t('edit_info.choose_province') }}</option>
                    <option :value="province.code" v-for="province in chinacode" :key="province.code">{{province.name}}</option>
                  </select>
                  <select v-model="formData.city.value">
                    <option value="">{{ $t('edit_info.choose_city') }}</option>
                    <option :value="city.code" v-for="city in getCitySelect" :key="city.code">{{city.name}}</option>
                  </select>
                </div>
                <div class="col-3">
                  <select v-model="formData.area.value" @change="handleAreaChange($event,'')">
                    <option value="">{{ $t('edit_info.choose_area') }}</option>
                    <option :value="area.code" v-for="area in getAreaSelect" :key="area.code">{{area.name}}</option>
                  </select>
                  <input type="text" :placeholder="$t('edit_info.zip')" v-model="formData.zip.value">
                </div>
                <div class="col-3">
                  <input type="text" :placeholder="$t('edit_info.street')" v-model="formData.address.value">
                </div>
              </div>
            </div>
            <div class="form-item show-on-pad-flex">
              <div class="form-title">{{ $t('edit_info.phone') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" placeholder="15258645" v-model="formData.phone.value">
                </div>
              </div>
            </div>
            <div class="form-item show-on-pad-flex">
              <div class="form-title required">{{ $t('edit_info.job') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('edit_info.job')" v-model="formData.job.value">
                  <!-- <select  v-model="formData.job.value">
                    <option value="1">学生</option>
                    <option value="2">家庭主妇</option>
                    <option value="3">老师</option>
                    <option value="4">服务员</option>
                    <option value="5">白领</option>
                    <option value="6">其他</option>
                  </select> -->
                </div>
              </div>
            </div>
          </div>
          <div class="form">
            <div class="form-item">
              <div class="form-title required">
                <div>{{ $t('edit_info.ship_addr1') }}<div class="required">{{ $t('form.required') }}</div></div>
                <div class="label-group">
                  <input type="checkbox" id="is_check" name="is_check" v-model="formData.is_check.value"><label class="square" for="is_check">{{ $t('edit_info.same_addr') }}</label>
                </div>  
              </div>
              <div class="form-content">
                <div class="col-3">
                  <select v-model="formData.province2.value" :disabled="formData.is_check.value">
                    <option value="">{{ $t('edit_info.choose_province') }}</option>
                    <option :value="province.code" v-for="province in chinacode" :key="province.code">{{province.name}}</option>
                  </select>
                  <select v-model="formData.city2.value" :disabled="formData.is_check.value">
                    <option value="">{{ $t('edit_info.choose_city') }}</option>
                    <option :value="city.code" v-for="city in getCitySelect2" :key="city.code">{{city.name}}</option>
                  </select>
                </div>
                <div class="col-3">
                  <select v-model="formData.area2.value" :disabled="formData.is_check.value" @change="handleAreaChange($event,'2')">
                    <option value="">{{ $t('edit_info.choose_area') }}</option>
                    <option :value="area.code" v-for="area in getAreaSelect2" :key="area.code">{{area.name}}</option>
                  </select>
                  <input type="text" :placeholder="$t('edit_info.zip')" v-model="formData.zip2.value" :disabled="formData.is_check.value">
                </div>
                <div class="col-3">
                  <input type="text" :placeholder="$t('edit_info.street')" v-model="formData.ship_addr1.value" :disabled="formData.is_check.value">
                </div>
                <div class="col-3 justify-center show-on-pad-flex mb-10">
                  <div class="label-group">
                    <input type="checkbox" id="is_check" name="is_check" v-model="formData.is_check.value"><label for="is_check">{{ $t('edit_info.same_addr') }}</label>
                  </div>  
                </div>
              </div>
            </div>
          </div>
          <div class="form">
            <div class="form-item">
              <div class="form-title">
                <div>{{ $t('edit_info.ship_addr2') }}</div>
              </div>
              <div class="form-content">
                <div class="col-3">
                  <select v-model="formData.province3.value">
                    <option value="">{{ $t('edit_info.choose_province') }}</option>
                    <option :value="province.code" v-for="province in chinacode" :key="province.code">{{province.name}}</option>
                  </select>
                  <select v-model="formData.city3.value">
                    <option value="">{{ $t('edit_info.choose_city') }}</option>
                    <option :value="city.code" v-for="city in getCitySelect3" :key="city.code">{{city.name}}</option>
                  </select>
                </div>
                <div class="col-3">
                  <select v-model="formData.area3.value" @change="handleAreaChange($event,'3')">
                    <option value="">{{ $t('edit_info.choose_area') }}</option>
                    <option :value="area.code" v-for="area in getAreaSelect3" :key="area.code">{{area.name}}</option>
                  </select>
                  <input type="text" :placeholder="$t('edit_info.zip')" v-model="formData.zip3.value">
                </div>
                <div class="col-3">
                  <input type="text" :placeholder="$t('edit_info.street')" v-model="formData.ship_addr2.value">
                </div>
              </div>
            </div>
            <div class="form-item hide-on-pad-flex">
              <div class="form-title">{{ $t('edit_info.phone') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" placeholder="15258645" v-model="formData.phone.value">
                </div>
              </div>
            </div>
            <div class="form-item hide-on-pad-flex">
              <div class="form-title required">{{ $t('edit_info.job') }}<div class="required">{{ $t('form.required') }}</div></div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('edit_info.job')" v-model="formData.job.value">
                  <!-- <select  v-model="formData.job.value">
                    <option value="1">学生</option>
                    <option value="2">家庭主妇</option>
                    <option value="3">老师</option>
                    <option value="4">服务员</option>
                    <option value="5">白领</option>
                    <option value="6">其他</option>
                  </select> -->
                </div>
              </div>
            </div>
          </div>
          <div class="form-desc">{{ $t('edit_info.item_desc1') }}</div>
          <div class="form">
            <div class="form-item">
              <div class="form-title required">
                <span>{{ $t('edit_info.mobile') }}<span :class="user.validation_ind==1?'color-red':'color-green'">{{ user.validation_ind==1 ? `(${$t('edit_info.not_verify')})` : `(${$t('edit_info.is_verify')})` }}</span></span>
                <div class="required">{{ $t('form.required') }}</div>
              </div>
              <div class="form-content">
                <div class="col-2 input-mix-btn" :class="{ 'mb-0':user.validation_ind==2 }">
                  <div 
                    class="btn show-on-pad-flex btn-orange"
                    v-if="user.validation_ind==1"
                    :disabled="getingCode"
                    @click="handleGetCode"
                  >{{ $t('btns.get_verify_code') }}{{ getingCode?`(${countNumber})`:'' }}</div>
                  <input type="text" placeholder="88942153535" v-model="formData.mobile.value">
                </div>
                <div class="col-1 mb-0 hide-on-pad">
                  <div 
                    :class="'btn mb-0 btn-orange'"
                    v-if="user.validation_ind==1"
                    :disabled="getingCode"
                    @click="handleGetCode"
                  >{{ $t('btns.get_verify_code') }}{{ getingCode?`(${countNumber})`:'' }}</div>
                </div>
                <div class="col-2 mb-0 input-mix-btn" v-if="user.validation_ind==1">
                  <div class="btn show-on-pad-flex btn-orange" @click="checkVerifyCode">{{ $t('btns.verify') }}</div>
                  <input type="text" :placeholder="$t('edit_info.verify_code_placeholder')" v-model="verifyCodeString">
                </div>
                <div class="col-1 mb-0 hide-on-pad" v-if="user.validation_ind==1">
                  <div :class="'btn mb-0 btn-orange'" @click="checkVerifyCode">{{ $t('btns.verify') }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title">{{ $t('edit_info.email') }}</div>
              <div class="form-content">
                <div class="col-2 mb-0 input-mix-btn">
                  <div class="btn btn-red show-on-pad-flex">{{ $t('btns.now') }}</div>
                  <input type="text" placeholder="abx123@gmail.com" v-model="formData.email.value">
                </div>
                <div class="col-1 mb-0 hide-on-pad">
                  <div class="btn btn-red mb-0">{{ $t('btns.now') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-desc">{{ $t('edit_info.item_desc2') }}</div>
          <div class="form">
            <div class="form-item">
              <div class="form-title">{{ $t('edit_info.tall') }}(CM)</div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('form.insert')" v-model="formData.height.value">
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title">{{ $t('edit_info.weight') }}(KG)</div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('form.insert')" v-model="formData.weight.value">
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title">{{ $t('edit_info.pants') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('form.insert')" v-model="formData.pants_length.value">
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title">{{ $t('edit_info.has_children') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="label-group hide-on-pad-flex">
                    <input type="radio" id="has_childY" name="has_child" value="1" v-model="formData.has_child.value"><label for="has_childY">{{ $t('form.yes') }}</label>
                  </div>
                  <div class="label-group hide-on-pad-flex">
                    <input type="radio" id="has_childN" name="has_child" value="2" v-model="formData.has_child.value"><label for="has_childN">{{ $t('form.no') }}</label>
                  </div>
                  <select class="show-on-pad" v-model="formData.has_child.value">
                    <option value="">{{ $t('form.choose') }}</option>
                    <option value="1">{{ $t('form.yes') }}</option>
                    <option value="2">{{ $t('form.no') }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title">{{ $t('edit_info.has_custom') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="label-group hide-on-pad-flex">
                    <input type="radio" id="used_indY" name="used_ind" value="1" v-model="formData.used_ind.value"><label for="used_indY">{{ $t('form.yes') }}</label>
                  </div>
                  <div class="label-group hide-on-pad-flex">
                    <input type="radio" id="used_indN" name="used_ind" value="2" v-model="formData.used_ind.value"><label for="used_indN">{{ $t('form.no') }}</label>
                  </div>
                  <select class="show-on-pad" v-model="formData.used_ind.value">
                    <option value="">{{ $t('form.choose') }}</option>
                    <option value="1">{{ $t('form.yes') }}</option>
                    <option value="2">{{ $t('form.no') }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title">{{ $t('edit_info.love_brand') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <input type="text" :placeholder="$t('form.insert')" v-model="formData.love_brand.value">
                </div>
              </div>
            </div>
          </div>
          <div class="btn btn-orange next-step" @click="nextStep(1)">{{ $t('btns.next_page') }}</div>
        </div>
        <div class="step-content-item" :class="{ active:step=='2' }">
          <div class="form">
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.user') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.username.value) }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.name') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.name.value) }}</div>
                </div>
              </div>
            </div>
            <!-- <div class="form-item">
              <div class="form-title required">姓名</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ formData.name.value | checkEmpty }}</div>
                </div>
              </div>
            </div> -->
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.gender') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(getSexText) }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.birthday') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(getBirthdayText) }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.addr') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(getFullAddress)}}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title ">{{ $t('edit_info.ship_addr1') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.is_check.value? $t('edit_info.same_addr') :getFullship_addr1) }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title ">{{ $t('edit_info.ship_addr2') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(getFullship_addr2) }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.phone') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.phone.value) }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.job') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.job.value) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="form">
            <div class="form-item">
              <div class="form-title ">{{ $t('edit_info.mobile') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.mobile.value)  }}<span :class="user.validation_ind==1?'red':'green'">{{ user.validation_ind==1 ? $t('edit_info.not_verify') : $t('edit_info.is_verify') }}</span></div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title ">{{ $t('edit_info.email') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.email.value)  }}<span class="green">{{ $t('edit_info.is_verify') }}</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="form">
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.tall') }}(CM)</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.height.value)  }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.weight') }}(KG)</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.weight.value)  }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.pants') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.pants_length.value)  }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.has_children') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ formData.has_child.value==1?$t('form.yes'):$t('form.no') }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.has_custom') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ formData.used_ind.value==1?$t('form.yes'):$t('form.no') }}</div>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-title required">{{ $t('edit_info.love_brand') }}</div>
              <div class="form-content">
                <div class="col-2">
                  <div class="show-value">{{ checkEmpty(formData.love_brand.value)  }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="btns flex">
            <div class="btn btn-orange next-step" @click="prevStep()">{{ $t('btns.prev_page') }}</div>
            <div class="btn btn-orange next-step" @click="nextStep(2)">{{ $t('btns.next_page') }}</div>
          </div>
        </div>
        <div class="step-content-item" :class="{ active:step=='3' }">
          <div class="success-content">{{ $t('edit_info.success') }}</div>
          <div class="btn btn-orange next-step" @click="nextStep(3)">{{ $t('btns.confirm') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserSideMenu from '../../components/UserSideMenu';
  import { get, set } from '../../utils/localStorage';
  import FormDataBase from './mock/formDataBase.js';
  import chinacode from './mock/chinacode.json';
  import { updateMemberData, getCode, verifyCode } from '../../api';
  import { cloudLoading } from "../../utils/tools.js";
  
  let mountData = true;
  export default {
    name: 'edit-info',
    data() {
      return {
        step: 1,
        year: [],
        mon: [],
        day: [],
        formData: FormDataBase,
        chinacode,
        user: '',
        verifyCodeString: '',
        getingCode: false,
        countNumber: 60,
        countNumberDefaul: 60, // 取得验证码的倒数设定值
      }
    },
    filters: {
      
    },
    created() {
      const year = [];
      const mon = [];
      const day = [];
      let now = new Date;
      for(let i = 0; i<=now.getFullYear() - 1920;i++) {
        year.push(i+1920);
      }
      for(let i = 1; i<=12;i++) {
        mon.push(i);
      }
      for(let i = 1; i<=31;i++) {
        day.push(i);
      }
      mon.length = 12;
      day.length = 31;
      this.year = year;
      this.mon = mon;
      this.day = day;

      const newFormData = this.formData;
      // 放入日期预设值
      newFormData.year.value = now.getFullYear();
      newFormData.mon.value = now.getMonth()+1;
      newFormData.day.value = now.getDate();

      // 放user已存在的资料
      const { user } = get('userInfo');
      console.log('userInfo',user);
      this.user = user;
      newFormData.username.value = user.username;
      newFormData.name.value = user.name;
      newFormData.sex.value = user.sex;
      if(user.birthday) {
        const birthday = user.birthday.split('-');
        newFormData.year.value = parseInt(birthday[0]);
        newFormData.mon.value = parseInt(birthday[1]);
        newFormData.day.value = parseInt(birthday[2]);
      }
      newFormData.province.value = user.province || '';
      
      newFormData.area.value = user.area || '';
      newFormData.city.value = user.city || '';
      newFormData.address.value = user.address || '';
      newFormData.zip.value = user.zip || '';

      newFormData.province2.value = user.province2 || '';
      
      newFormData.area2.value = user.area2 || '';
      newFormData.city2.value = user.city2 || '';
      newFormData.ship_addr1.value = user.ship_addr1 || '';
      newFormData.zip2.value = user.zip2 || '';
      newFormData.is_check.value = user.is_check ? user.is_check==1 ? true : false : '';

      newFormData.province3.value = user.province3 || '';
      
      newFormData.area3.value = user.area3 || '';
      newFormData.city3.value = user.city3 || '';
      newFormData.ship_addr2.value = user.ship_addr2 || '';
      newFormData.zip3.value = user.zip3 || '';
      
      newFormData.phone.value = user.phone || '';
      newFormData.job.value = user.job || '';
      newFormData.mobile.value = user.mobile || '';
      newFormData.email.value = user.email || '';

      newFormData.height.value = user.height || '';
      newFormData.weight.value = user.weight || '';
      newFormData.pants_length.value = user.pants_length || '';
      newFormData.has_child.value = user.has_child || '';
      newFormData.used_ind.value = user.used_ind || '';
      newFormData.love_brand.value = user.love_brand || '';
      
      this.formData = newFormData;
      // 加这个的原因是因为我在改变地址的选择器时会清掉该栏位之下的值
      // 例如province改变了area和city会被清空
      // 但是批量赋值的时候不应该做这件事情
      // 因此用这个变数来判断是否是为批量赋值
      setTimeout(() => {
        mountData = false;
      }, 1000);
    },
    mounted() {
      this.$nextTick(() => {
        console.log('mounted');
      })
    },
    destroyed() {
      mountData = true;
    },
    components: {
      UserSideMenu
    },
    computed: {
      getAreaSelect() {
        return this.getAreaSelectData();
      },
      getCitySelect() {
        return this.getCitySelectData();
      },
      getAreaSelect2() {
        return this.getAreaSelectData(2);
      },
      getCitySelect2() {
        return this.getCitySelectData(2);
      },
      getAreaSelect3() {
        return this.getAreaSelectData(3);
      },
      getCitySelect3() {
        return this.getCitySelectData(3);
      },
      getFullAddress() {
        return this.getFullAddressText();
      },
      getFullship_addr1() {
        return this.getFullAddressText(2);
      },
      getFullship_addr2() {
        return this.getFullAddressText(3);
      },
      getLineWidth() {
        switch(this.step) {
          case 1:
            return '30px';
            break;
          case 2:
            return '49%';
            break;
          case 3:
            return 'calc(100% - 32px)';
            break;
        }
      },
      getSexText: function() {
        switch(this.formData.sex.value) {
          case 1:
          case '1':
            return this.$t('edit_info.male');
            break;
          case 2:
          case '2':
            return this.$t('edit_info.female');
            break;
          case 3:
          case '3':
            return this.$t('edit_info.no_comment');
            break;
        }
      },
      getBirthdayText: function() {
        const form = this.formData;
        return `${form.year.value}${this.$t('edit_info.year')}${form.mon.value}${this.$t('edit_info.mon')}${form.day.value}${this.$t('edit_info.day')}`;
      }
    },
    methods: {
      checkEmpty(value) {
        if(String(value).trim() != '' && value != null) {
          return value;
        }else{
          return this.$t('format.no_data');
        }
      },
      async nextStep(step) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        switch(step) {
          case 1:
            // 判断一下是否写完了
            if(!this.checkFromDone()) return;
            this.step++;
            break;
          case 2:
            // 送出表单
            // const formatFormData = this.formData.map(item =>  value);
            const formatFormData = {};
            let loading;
            for (const key in this.formData) {
              if (this.formData.hasOwnProperty(key)) {
                const element = this.formData[key];
                formatFormData[key] = element.value;
              }
            }
            try {
              loading = cloudLoading();
              await updateMemberData(formatFormData);
              this.step++;
            } catch (error) {
              
            }
            loading.close();
            break;
          case 3:
            this.step = 1;
            break;
        }
      },
      prevStep() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        this.step--;
      },
      getAreaSelectData(i='') {
        console.log('getCitySelectData',i);
        // 市变化了这样就要把city清空
        if(!mountData) {
          this.formData[`area${i}`].value = '';
        }
        if(this.formData[`city${i}`].value && this.formData[`city${i}`].value!='0') {
          const areaData = this.chinacode.filter(item => item.code==this.formData[`province${i}`].value)[0].children.filter(item => item.code==this.formData[`city${i}`].value)[0].children;
          return areaData;
          // return [];
        }else{
          return [];
        }
      },
      getCitySelectData(i='') {
        console.log('getAreaSelectData',i);
        // 省份变化了这样就要把area和city清空
        if(!mountData) {
          this.formData[`area${i}`].value = '';
          this.formData[`city${i}`].value = '';
        }
        if(this.formData[`province${i}`].value && this.formData[`province${i}`].value!='0') {
          const cityData = this.chinacode.filter(item => item.code==this.formData[`province${i}`].value)[0].children;
          return cityData;
          // return [];
        }else{
          return [];
        }
      },
      getFullAddressText(i='') {
        const zip = this.formData[`zip${i}`].value;
        let province = '';
        console.log('---------*******----------');
        console.log(this.formData[`province${i}`].value);
        console.log(this.formData[`city${i}`].value);
        console.log(this.formData[`area${i}`].value);
        console.log('---------*******----------');
        if(this.formData[`province${i}`].value && this.formData[`province${i}`].value!='0') {
          province = this.chinacode.filter(item => item.code==this.formData[`province${i}`].value)[0].name;
        }
        let city = '';
        if(this.formData[`city${i}`].value && this.formData[`city${i}`].value!='0') {
          city = this.chinacode.filter(item => item.code==this.formData[`province${i}`].value)[0].children.filter(item => item.code==this.formData[`city${i}`].value)[0].name;
        }
        let area = '';
        if(this.formData[`area${i}`].value && this.formData[`area${i}`].value!='0') {
          area = this.chinacode.filter(item => item.code==this.formData[`province${i}`].value)[0].children.filter(item => item.code==this.formData[`city${i}`].value)[0].children.filter(item => item.code==this.formData[`area${i}`].value)[0].name;
        }
        let address = '';
        if(i=='') address = this.formData.address.value;
        if(i==2) address = this.formData.ship_addr1.value;
        if(i==3) address = this.formData.ship_addr2.value;
        
        // const address = this.formData.address.value;
        console.log('getFullAddressText',i);
        console.log(`${zip} ${province} ${city} ${area} ${address}`);
        return `${zip} ${province} ${city} ${area} ${address}`;
      },
      checkFromDone() {
        let empty = false;
        for (const column in this.formData) {
          if (this.formData.hasOwnProperty(column)) {
            const element = this.formData[column];
            if(element.required) {
              if(element.value=='' || element.value==null) {
                if(column=='province2' || column=='area2' || column=='city2' || column=='zip2' || column=='ship_addr1') {
                  if(!this.formData.is_check.value) {
                    empty = true;
                  }
                }else{
                  empty = true;
                }
              }
            }
          }
        }
        if(empty) {
          this.$message.error(this.$t('alert_message.done_require_input'));
          return false;
        }else{
          return true;
        }
      },
      handleAreaChange(e,index) {
        const zip = e.target.value;
        console.log('e',e);
        console.log('e.target',e.target);
        console.log('zip',zip);
        this.$set(this.formData[`zip${index}`],'value',zip);
      },
      async handleGetCode() {
        if(this.getingCode) return;
        const loadingInstance = this.$loading();
        console.log(this.formData);
        try {
          await getCode({ mobile:this.formData.mobile.value });
          loadingInstance.close();
          this.$message({
            message: this.$t('alert_message.send_success'),
            type: "success",
          })
          this.countNumber = this.countNumberDefaul;
          this.getingCode = true;
          const countingInterval = setInterval(() => {
            if(this.countNumber==0){
              this.getingCode = false;
              clearInterval(countingInterval);
            }
            this.countNumber--;
          }, 1000);
        } catch (error) {
          console.log(error);
          loadingInstance.close();
          // this.$message({
          //   message: "发送失败！",
          //   type: "error",
          // })
        }
      },
      async checkVerifyCode() {
        if(this.verifyCodeString=='') {
          this.$message({
            message: this.$t('alert_message.verify_code_placeholder'),
            type: 'warning'
          });
          return;
        }
        try {
          const loadingInstance = this.$loading();
          const res = await verifyCode({ mobile: this.formData.mobile.value, code: this.verifyCodeString });
          loadingInstance.close();
          // todo
          // 明天问 verification==1 通过
          if(res.verification==1) {
            this.user.validation_ind=2;
            const userInfo = get('userInfo');
            userInfo.user.validation_ind=2;
            set('userInfo', userInfo);
            this.$store.commit('SET_USER_INFO', userInfo);
          }else{
            this.$message({
              message: this.$t('alert_message.verify_code_placeholder'),
              type: "error",
            });
          }
        } catch (error) {
          console.log(error);
          loadingInstance.close();
          this.$message({
            message: this.$t('alert_message.verify_code_placeholder'),
            type: "error",
          });
        }
      }
    }
  }
</script>

<style lang="less" scoped>

.edit-info-page {
  .steps {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    padding-left: 30%;
    position: relative;
    .step-item {
      font-weight: 400;
      color: #707070;
      &.active {
        color: #FF5214;

      }
    }
    @media (max-width: 992px) {
      padding-left: 0%;
      padding: 0 16px;
      border-bottom: unset;
      .line {
        position: absolute;
        width: calc(100% - 32px);
        height: 3px;
        background: #FF5214;
        border-radius: 3px;
        z-index: -1;
        top: 50%;
        transform: translateY(-50%);
      }
      .line-bg {
        position: absolute;
        width: calc(100% - 32px);
        height: 3px;
        background: #F5F4F8;
        border-radius: 3px;
        z-index: -1;
        top: 50%;
        transform: translateY(-50%);
      }
      .step-item:nth-child(3) {
        margin-left: 30px;
      }
      .step-item:nth-last-child(1) {
        margin-right: 30px;
      }
      .step-index {
        background: white;
        color:#E6E6E6;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        border: 2px solid #E6E6E6;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          height: 28px;
          width: 28px;
          left: -5px;
          top: -5px;
          border: 3px solid white;
          border-radius: 50%;
        }
      }
      .step-item {
        font-weight: 400;
        color: #707070;
        &.active {
          .step-index {
            background: #FF5214;
            border: 2px solid #FF5214;
            color: white;
          }
        }
      }
    }
  }
  .step-content {
    .step-content-item {
      display: none;
      &.active {
        display: block;
      }
    }
  }
  .form-desc {
    margin: 30px 0 20px 0;
    @media (max-width: 992px) {
      margin: 60px 0 10px 0;
      padding-bottom: 10px;
      font-size: 13px;
      border-bottom: 1px solid #E6E6E6;
      text-align: center;
    }
  }
  .success-content {
    height: 300px;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #707070;
    @media (max-width: 992px) {
      border-bottom: unset;
    }
  }
  .form {
    .btn {
      margin-bottom: 20px;
      width: 100%;
      margin-left: 20px;
    }
    .form-item {
      display: flex;
      border-bottom: 1px solid #E6E6E6;
      &:nth-child(1) {
        border-top: 1px solid #E6E6E6;
      }
      .form-title {
        background: #F3F3F3;
        width: 240px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        &.required {
          padding-right: 85px;
        }
        .required {
          position: absolute;
          color: #FF5214;
          border: 1px solid #FF5214;
          padding: 3px;
          border-radius: 5px;
          right: 20px;
          font-size: 14px;
        }
        .label-group {
          margin-top: 10px;
          input[type="checkbox"] {
            flex: 0 0 16px;
          }
          // label {
          //   &::before {
          //     border-radius: 0;
          //   }
          //   &::after {
          //     border-radius: 0;
          //   }
          // }
        }
      }
      .form-content {
        flex: 1;
        padding: 20px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .col-1,.col-2,.col-3 {
          margin-bottom: 20px;
          &:nth-last-child(1) {
            margin-bottom: 0;
          }
        }
        .col-1 {
          flex: 0 0 33.333%;
          display: flex;
        }
        .col-2 {
          flex: 0 0 66.666%;
          display: flex;
        }
        .col-3 {
          flex: 0 0 100%;
          display: flex;
        }
        input[type="text"] {
          margin-right: 20px;
          padding: 10px;
          // 下面这两行 为了修正inpu在flex里面会有溢出的问题，随便给个比预期小的就好
          min-width: 16px;
          width: 16px;
          &:nth-last-child(1) {
            margin-right: 0;
          }
        }
        select {
          flex: 1;
          margin-right: 20px;
          font-size: 13px;
          &:nth-last-child(1) {
            margin-right: 0;
          }
        }
        .show-value {
          width: 100%;
          span {
            position: absolute;
            top: 14px;
            right: 10px;
            border: 1px solid #fff;
          }
          span.red {
            color: #07BB6B;
            border-color: #07BB6B;
            padding: 5px;
            width: 100px;
            text-align: center;
          }
          span.green {
            color: #A72121;
            border-color: #A72121;
            padding: 5px;
            width: 100px;
            text-align: center;
          }
        }
      }
    }
    @media (max-width: 992px) {
      background: #F7F8FA;
      border-radius: 5px;
      box-shadow: 0px 4px 8px 4px rgba(0,0,0,.15);
      margin-bottom: 30px;
      .btn {
        font-size: 13px;
      }
      .form-item {
        flex-direction: column;
        padding: 10px 5px;
        border-top: unset !important;
        border-bottom: unset;
        .form-title {
          width: 100%;
          padding: 10px 0;
          background: unset;
          font-size: 14px;
          padding-left: 10px;
          &.required {
            position: relative;
            &::before {
              content: '*';
              position: absolute;
              top: 9px;
              left: 1px;
            }

          }
          .required {
            display: none;
          }
          .label-group {
            display: none;
          }
        }
        .form-content {
          width: 100%;
          padding: 0;
          .col-1,.col-2,.col-3 {
            flex: 0 0 100%;
            &.input-mix-btn {
              position: relative;
              .btn {
                position: absolute;
                right: 0;
                top: 0;
                width: 100px;
                height: 100%;
                border-top-right-radius: 6px;
                border-bottom-right-radius: 6px;
              }
              input {
                padding-right: 100px;
              }
            }
          }
          input,select {
            border: 1px solid #E6E6E6;
            border-radius: 6px;
          }
          .label-group {
            input[type="checkbox"],input[type="radio"] {
              flex: 0 0 16px;
            }
            label {
              &::before {
                background: white;
                border-color: #E6E6E6;
              }
              &::after {
                // border-radius: 10px;
              }
            }
          }
          .show-value {
            border: 1px solid #E6E6E6;
            text-align: center;
            width: 100%;
            padding: 10px;
            border-radius: 6px;
            position: relative;
            span {
              position: absolute;
              top: 5px;
              right: 10px;
            }
            span.red {
              color: #07BB6B;
              border: unset;
            }
            span.green {
              color: #A72121;
              border: unset;
            }
          }
        }
      }
    }
  }
  .next-step {
    width: 100px;
    margin: auto;
    margin-top: 30px;
    margin-bottom: 50px;
    @media (max-width: 992px) {
      width: 100%;
      margin-top: 40px;
      margin-bottom: 20px;
      margin-right: 20px;
      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }
}


</style>